import { Link, useLocation } from 'react-router-dom';
import { UserButton, SignedIn } from '@clerk/clerk-react';
import {
  LayoutDashboard,
  Battery,
  Zap,
  Users,
  ClipboardList,
  FileText
} from 'lucide-react';
import { useRole } from '../hooks/useRole';

const navItems = [
  { path: '/', label: 'Dash', icon: LayoutDashboard },
  { path: '/packs', label: 'Packs', icon: Battery },
  { path: '/cells', label: 'Cells', icon: Zap },
  { path: '/customers', label: 'Customers', icon: Users },
  { path: '/tests', label: 'Logs', icon: ClipboardList },
  { path: '/audit', label: 'Audit', icon: FileText },
];

export default function BottomNav() {
  const location = useLocation();
  const { isEditor } = useRole();

  return (
    <nav className="fixed bottom-0 left-0 right-0 glass-effect shadow-[0_-8px_20px_rgba(0,0,0,0.08)] z-50 md:hidden pb-safe">
      <div className="flex justify-around items-stretch h-16">
        {navItems
          .filter(item => item.path !== '/audit' || isEditor)
          .map((item) => {
          const isActive = location.pathname === item.path ||
            (item.path !== '/' && location.pathname.startsWith(item.path));

          const Icon = item.icon;

          return (
            <Link
              key={item.path}
              to={item.path}
              className={`flex flex-col items-center justify-center flex-1 transition-all duration-300 relative ${isActive
                ? 'text-blue-600'
                : 'text-gray-400 hover:text-gray-600'
                }`}
            >
              {isActive && (
                <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-8 h-1 bg-blue-600 rounded-full"></div>
              )}
              <Icon
                size={22}
                className={`transition-all duration-300 ${isActive ? 'mb-1 scale-110' : ''}`}
              />
              {isActive && (
                <span className={`text-[9px] font-bold uppercase tracking-tight text-blue-600`}>
                  {item.label}
                </span>
              )}
            </Link>
          );
        })}
        <div className="flex flex-col items-center justify-center flex-1 relative">
          <div className={`p-0.5 rounded-full border-2 transition-all duration-300 border-transparent`}>
            <SignedIn>
              <UserButton
                afterSignOutUrl="/"
                appearance={{
                  elements: {
                    userButtonAvatarBox: "w-6 h-6"
                  }
                }}
              />
            </SignedIn>
          </div>
          <span className="sr-only">Profile</span>
        </div>
      </div>
    </nav>
  );
}


